import React, { useEffect, useState } from 'react'
// import { ASSETS_FOLDER } from '../../assets';
import { VscChevronDown as Arrow, VscClose } from 'react-icons/all';
// import { AmorinWiseBackground, WicanderBackground } from '../../assets'
import { WicanderBackground } from '../../assets'
import { Container, ImageContainer, BtnClose, StyledMain, ButtonMenu, TitleSection, ContainerImageVideo, Description  } from './index.styled'
const collections = require('./../../assets/mock-data/menu-popup-cork.json')

function PopupCork({ content, open = true, showImage = true }) {
  const [ menu, setMenuState ] = useState([]);

  const activeMenu = (selected) => {
    const oldMenu = [...menu];
    const choosed = oldMenu.map(item => {
      if(item.id === selected.id ) item.active = !item.active;
      else item.active = false;
      return item;
    })

    setMenuState(choosed);
  }


  const renderImage = () => {
    if(showImage){
      return (
        <ContainerImageVideo>
          <ImageContainer>
            {/* <img src={`${ASSETS_FOLDER}/${AmorinWiseBackground}`} alt="popup"/> */}
            {/* <img src={WicanderBackground} alt="popup"/> */}
            <img src={WicanderBackground} alt="popup"/>
          </ImageContainer>
          
        </ContainerImageVideo>
      )
    }
    return null
  }

  useEffect(() => {
    const menu = collections.map((item, index) => ({
      id: index,
      title: item.title,
      description: item.description,
      active: false
    }))

    setMenuState(menu);
  }, [])

  return (
    <Container className={`popuplayer ${open ? 'open' : 'closed'}`}>
      <StyledMain >
        <BtnClose onClick={() => console.log("close")}><VscClose /></BtnClose>
        {renderImage()}
      </StyledMain>
      <StyledMain className="menu-cook">
        <TitleSection>Cork Benefits</TitleSection>
        { menu.map((item, index) => (
            <React.Fragment key={index}>
            <ButtonMenu 
              className={item.active === true ? 'divisor active' : 'divisor'}
              onClick={() => activeMenu(item)} 
            >{item.title}<Arrow size={20} /></ButtonMenu>
            {item.active === true && <Description>{item.description}</Description>}
            </React.Fragment>
          ))   
        }
      </StyledMain>
      
    </Container>
  )
}

export default PopupCork;